import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#3B7E3D',
    },
    secondary: {
      main: '#418B43',
    },
    listOpened: {
      main: '#1EC6A8',
    },
    listSelected: '#3B7E3D',
      background: {
      list: '#E8F0FE',
      nested: '#f0f4ff',
      default: '#E4E4E4',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif'
  },
  shape: {
    borderRadius: 12,
  },
  spacing: 0,
  overrides: {
    MuiButtonBase: {
      root: {},
    },
    MuiTableHead: {
      root: {
        background: 'linear-gradient(90deg, #3B7E3D 0%, #418B43 100%)'
      }
    },
    MuiTableCell: {
      root: {
        backgroundColor: 'transparent !important'
      },
      header: {
        backgroundColor: 'transparent !important'
      },
      body: {
        color: '#1A1A1A !important'
      }
    },
    MuiTableBody: {
      root: {
        backgroundColor: '#FFFFFF',
        color: '#1A1A1A',
      }
    },
    MuiDataGrid: {
      root: {
        backgroundColor: '#FFFFFF',
        color: '#1A1A1A',
      }
    },
    MuiCheckbox: {
      root: {
        color: '#3B7E3D',
      }
    },
    MuiSvgIcon: {
      root: {
        fill: '#1A1A1A'
      }
    },
    MuiMenuItem: {
      root: {
        background: '#FFFFFF',
        justifyContent: 'center',
        color: '#1A1A1A',
        '&:hover': {
          backgroundColor: '#E8F0FE',
        },
        '@media(max-width: 600px)': {
          minHeight: 'auto'
        },
      }
    },
    MuiTypography: {
      root: {
        color: '#1A1A1A',
      }
    },
    MuiInputBase: {
      root: {
        '& .Mui-disabled': {
          backgroundColor: '#f2f2f2',
        }
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': { backgroundColor: 'rgba(59, 126, 61, 0.08)' }
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 14
      }
    },
    MuiCssBaseline: {
      '@global': {
        html: {},
        body: {
          fontSize: 16,
          fontFamily: 'Poppins, sans-serif',
          backgroundColor: '#E4E4E4',
          color: '#1A1A1A'
        },
      },
    },
    MuiContainer: {
      maxWidthLg: {
        padding: 0,
        maxWidth: 1140,
        '@media(min-width: 1280px)': {
          maxWidth: 1140,
        },
      },
    },
    MuiButton: {
      root: {
        backgroundColor: '#418B43',
        textTransform: 'none',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#367237',
        },
      },
      containedPrimary: {
        background: '#3B7E3D',
        borderRadius: '8px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 'bold',
        fontSize: '16px',
        color: '#FFFFFF',
        '&:hover': {
          background: '#316832',
        },
      },
      contained: {
        color: 'white',
      },
      text: {
        color: '#3B7E3D',
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: 'rgba(59, 126, 61, 0.08)',
        },
      },
      label: {
        padding: '0px 10px',
      },
      outlined: {
        backgroundColor: 'transparent',
        border: '1px solid #3B7E3D',
        color: '#3B7E3D',
        '&:hover': {
          backgroundColor: 'rgba(59, 126, 61, 0.08)',
        },
      },
    },
    MuiInput: {
      underline: {
        '&::before': {
          border: 'none',
        },
        '&::after': {
          border: 'none',
        },
        '&:hover:not(.Mui-disabled):before': {
          border: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
        color: '#1A1A1A',
      },
      notchedOutline: {
        borderRadius: '8px',
        border: '1px solid #CCCCCC !important',
      },
      adornedEnd: {
        paddingRight: 0,
        '& .MuiIconButton-root': {
          padding: '15px',
          borderRadius: '8px',
          border: 'none',
        },
        '& .MuiIconButton-edgeEnd': {
          marginRight: '0px'
        }
      },
    },
    MuiAppBar: {
      colorPrimary: {
        color: '#FFFFFF',
        backgroundColor: '#3B7E3D',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      },
    },
    MuiListItem: {
      root: {},
      button: {
        '&:hover': {
          backgroundColor: 'rgba(59, 126, 61, 0.08)'
        }
      }
    },
    MuiPaper: {
      elevation8: {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
      },
      elevation2: {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      },
    },
  },
  MuiListItemText: {
    root: {
      color: '#1A1A1A'
    }
  },
  MuiPaper: {
    outlined: {
      padding: 20,
    },
  },
  MuiCheckbox: {
    color: '#3B7E3D !important',
    fill: '#3B7E3D !important',
    colorSecondary: {
      color: '#3B7E3D !important',
      fill: '#3B7E3D !important',
      '&$checked': {
        color: '#3B7E3D !important',
      },
    },
    colorPrimary: {
      color: '#3B7E3D !important',
      fill: '#3B7E3D !important',
      '&$checked': {
        color: '#3B7E3D !important',
      },
    },
  },
  props: {
    MuiInputLabel: {
      style: { color: '#666666' },
    },
    MuiFormControl: {
      fullWidth: true,
    },
    MuiTab: {
      disableRipple: true,
    },
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiButton: {
      disableRipple: true,
    },
    MuiCheckbox: {
      disableRipple: true,
    },
    MuiTextField: {
      variant: 'outlined',
      margin: 'normal',
      autoComplete: 'off',
      fullWidth: true,
      InputLabelProps: {
        shrink: true,
        style: { color: '#3B7E3D' },
      },
    },
    MuiPaper: {
      elevation: 8,
    },
    MuiCard: {
      elevation: 8,
    },
    MuiOutlinedInput: {},
  },
});
